import React from "react";

export default function LinkedInIcon({ width = "17", height = "17", className = "" }) {
  return (
    <svg 
      width={width} 
      height={height} 
      className={className} 
      viewBox="0 0 17 17" 
      fill="currentColor"
      aria-hidden="true"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M17 17H13.507V11.0507C13.507 9.41955 12.8872 8.50802 11.5962 8.50802C10.1917 8.50802 9.45791 9.45661 9.45791 11.0507V17H6.09167V5.66667H9.45791V7.19327C9.45791 7.19327 10.4701 5.32042 12.8751 5.32042C15.279 5.32042 17 6.78838 17 9.82443V17ZM2.07575 4.18266C0.929134 4.18266 0 3.24623 0 2.09133C0 0.936424 0.929134 0 2.07575 0C3.22236 0 4.15094 0.936424 4.15094 2.09133C4.15094 3.24623 3.22236 4.18266 2.07575 4.18266ZM0.337565 17H3.84769V5.66667H0.337565V17Z" fill="currentColor"/>
    </svg>
  );
}